export const VNLocalizeStrings = {
  //Most used message notification
  GlobalMessage: {
    UpdateSuccessfully: "Cập nhật thành công !",
    UpdateFailed: "Cập nhật thất bại",
    CreateSuccessfully: "Tạo mới thành công !",
    CreateFailed: "Tạo mới thất bại",
    DeleteSuccessfully: "Xóa thành công !",
    DeleteFailed: "Xóa thất bại",
    DeleteConfirmation: "Bạn xác nhận xóa phần tử này ?",
    ResetSuccessfully: "Làm mới thành công !",
    ResetFailed: "Làm mới thất bại !",
    InvalidVariants: "Chọn Biến thể khác Tất cả",
    InvalidInventory: "Kho cần khác Tất cả để có thể chọn",
    InvalidProductList: "Chọn loại hàng hóa khác Tất cả để chọn được danh sách",
    InvalidVariant: "Loại hàng hóa cần khác Tất cả để có thể chọn",
    Exporting: "Đang xuất Excel...",
    ExcelForWalletTransaction:
      "Vui lòng chọn Loại hàng hóa và Hình thức giao dịch khác Tất cả để xuất Excel !",
    All: "Tất cả",
    Name: "Nhập tên...",
    Code: "Nhập mã...",
    Type: "Chọn loại...",
    Goods: "Chọn hàng hóa",
    Parter: "Chọn đối tác",
    Supplier: "Chọn nhà cung cấp",
    Status: "Chọn trạng thái",
    Phone: "Nhập số điện thoại...",
    Address: "Nhập địa chỉ...",
    Fax: "Nhập số fax...",
    Cover: "Vui lòng nhập link dưới dạng URL",
    Description: "Nhập mô tả...",
    Warehouse: "Vui lòng chọn kho",
    Inventory: "Vui lòng chọn ngăn kho",
    Variant: "Vui lòng chọn biến thể",
    Error: "Có lỗi xảy ra: ",
    Email: "Vui lòng nhập đúng định dạng Email !",
    ShortDes: "Nhập mô tả ngắn",
    InvalidAmount: "Tổng hàng không được rỗng",
    TimeLimit: "Phạm vi tìm kiếm tối đa là 20 ngày",
    LoginSuccessfully: "Đăng nhập thành công !",
    InvalidUsername: "Mời nhập tên tài khoản",
    InvalidPassword: "Mời nhập mật khẩu",
    SignupSuccessfully: "Đăng ký thành công, vui lòng đăng nhập",
    NoAccount: "Đi đến Đăng ký",
    BackToSignin: "Quay lại Đăng nhập",
    NeedPasswordConfirm: "Vui lòng nhập đúng mật khẩu",
    ChangePassSuccessfully: "Đổi mật khẩu thành công, vui lòng đăng nhập lại",
    ChangePassFailed: "Đổi mật khẩu thất bại",
    Importing: "Đang nhập",
    ApproveSuccessfully: "Duyệt phiếu thành công",
    ApproveFailed: "Duyệt phiếu thất bại",
    ApproveAksing: "Bạn xác nhận duyệt phần tử này ?",
    InvalidFeatures: "Dữ liệu tính năng có thay đổi, vui lòng đăng nhập !",
    InvalidToken: "Dữ liệu người dùng thiếu token, vui lòng đăng nhập !",
    InvalidUserInfo:
      "Thông tin tài khoản có thay đổi hoặc chưa có, vui lòng đăng nhập !",
    InvalidFile: "Vui lòng nhập một file",
    CannotOperate:
      "Người dùng sẽ không thể thao tác màn hình khi hệ thống đang nhập kho",
    ExportCannotOperate:
      "Người dùng sẽ không thể thao tác màn hình khi hệ thống đang xuất hoặc chuyển kho",
    ConfirmToProcess: "Xác nhận để tiếp tục",
    CopiedInfo: "Đã lưu giá trị",
    CopiedCode: "Đã lưu mã vào bộ nhớ tạm",
    Fields: "Chọn trường định danh",
    InvalidValue: "Nhập giá trị cho",
    NeedValidValue: "cần có giá trị",
    TokenExpired: "Token tài khoản đã hết hạn, vui lòng đăng nhập lại !",
    Note: "Vui lòng nhập Ghi chú...",
    ValidVal: "Nhập giá trị muốn tìm...",
    NotAllowedToUse: "Cần cấp quyền",
    AlreadyHasCopied: "Đã có giá trị trong bộ nhớ tạm",
    NeedPermisson: "Vui lòng cấp quyền truy cập bộ nhớ tạm",
  },
  //Most used selection labels
  GlobalSelections: {
    Active: "Hoạt động",
    Inactive: "Không hoạt động",
    Import: "Giao dịch nhập",
    Export: "Giao dịch xuất",
    Physical: "Physical",
    Online: "Online",
    GroupProductType: "Loại nhóm hàng hóa",
    ProductType: "Loại hàng hóa",
    PhysicalTopup: "Direct Physical",
    Inner: "Nội thành",
    Suburb: "Ngoại thành",
    Visible: "Hữu hình",
    Invisible: "Vô hình",
    SearchedValue: "Giá trị muốn tìm",
  },
  //Instructions feature
  Instructions: {
    ProductsSearchingTitle: "Hướng dẫn tìm hàng hóa theo kho",
    ProductsSearching:
      "Có 4 Filter quan trọng ảnh hưởng tới danh sách hàng hóa bên dưới khi tìm kiếm: Kho, Ngăn kho, Loại hàng hóa và Biến thể",
    Warehouse:
      "Mỗi kho sẽ cho ra từng ngăn kho riêng biệt, và danh sách hàng hóa sẽ dựa theo từng ngăn kho mà thể hiện bên dưới. Chọn một kho để có thể có danh sách ngăn kho",
    Inventory:
      "Chọn một ngăn kho cần tìm kiếm, danh sách hàng hóa bên dưới phụ thuộc vào tên ngăn kho đã chọn ở đây",
    CategoryForProducts:
      "Trong từng hàng hóa sẽ có thông tin loại hàng hóa và tên biến thể, có thể dựa vào tên hàng hoặc xem ở chi tiết. Từng loại hàng hóa sẽ có danh sách các biến thể, lưu ý chọn loại hàng hóa khác Tất cả để có thể chọn biến thể phù hợp",
    Category:
      "Từng loại hàng hóa sẽ có danh sách các biến thể, lưu ý chọn loại hàng hóa khác Tất cả để có thể chọn biến thể phù hợp",
    Variant:
      "Chọn tên biến thể cần tìm trong danh sách hàng hóa, mặc định sẽ lấy Tất cả biến thể trong danh sách hàng hóa đang hiển thị",
  },
  //Most used button labels
  GlobalButtons: {
    Search: "Tra cứu",
    Reset: "Làm mới bộ lọc",
    Update: "Cập nhật",
    Add: "Thêm mới",
    Details: "Chi tiết",
    Delete: "Xóa",
    ExcelExport: "Xuất Excel",
    WalletTransactionReports: "Xuất Báo cáo ví",
    ProductsReport: "Báo cáo hàng hóa",
    Actions: "Hành động",
    Confirm: "Xác nhận",
    Cancel: "Quay lại",
    Guides: "Hướng dẫn tìm kiếm",
    ExportImportTransfer: "Nhập - Xuất",
    ExportTransfer: "Xuất kho / Chuyển kho",
    Approve: "Duyệt",
    CreateTicket: "Tạo phiếu",
    Download: "Tải xuống",
  },
  //Most used labels
  GlobalLabels: {
    Warehouse: "Kho",
    Name: "Tên",
    Code: "Mã",
    Type: "Loại",
    Inventory: "Ngăn kho",
    Month: "Tháng",
    Year: "Năm",
    Email: "Email",
    Variant: "Mã biến thể ( SKU )",
    Variants: "Biến thể",
    Date: "Ngày",
    CreatedDate: "Thời gian tạo",
    UpdatedDate: "Thời gian cập nhật",
    Partner: "Đối tác",
    Supplier: "Nhà cung cấp",
    Serial: "Mã serial",
    Image: "Hình ảnh",
    Phone: "Số điện thoại",
    Fax: "Số fax",
    Cover: "Link hình ảnh",
    Male: "Nam",
    Female: "Nữ",
    Description: "Mô tả",
    Category: "Loại hàng hóa",
    ProductType: "Mẫu hàng",
    Total: "Tổng cộng",
    Import: "Đã nhập",
    Export: "Đã xuất",
    DocumentLicense: "Mã chứng từ",
    Status: "Trạng thái",
    NoInfo: "Không có thông tin",
    ProductList: "Danh sách sản phẩm",
    Currency: "VND",
    Loading: "Loading",
    Transaction: "Giao dịch",
    Percent: "%",
    Income: "Doanh thu",
    Product: "Sản phẩm",
    Address: "Địa chỉ",
    Note: "Ghi chú",
    Order: "Order",
    PleaseWait: "Vui lòng chờ...",
    Yes: "Có",
    No: "Không",
    Area: "Khu vực",
    ExportDestroy: "Xuất hủy hàng",
    Login: "Đăng nhập",
    Signup: "Đăng ký",
    PassConfirm: "Xác nhận mật khẩu",
    Password: "Mật khẩu",
    Username: "Tên tài khoản",
    Logout: "Đăng xuất",
    ChangePass: "Đổi mật khẩu",
    OldPass: "Mật khẩu hiện tại",
    NewPass: "Mật khẩu mới",
    ConfirmNewPass: "Xác thực mật khẩu mới",
    Home: "Trang chủ",
    Attention: "Lưu ý",
    GeneralTransaction: "Giao dịch chung",
    Succeed: "Thành công",
    Failed: "Thất bại",
    SearchWithName: "Tìm theo tên",
    SearchWithCode: "Tìm theo mã",
    SearchWithSku: "Tìm theo SKU",
    RelatedProduct: "Tìm toàn cục",
  },
  //Sidebar Labels
  Sidebar: {
    Generals: "Tổng quan",
    TransactionHistory: "Giao dịch",
    Products: "Hàng hóa",
    Partners: "Đối tác",
    Inventory: "Ngăn kho",
    Category: "Loại hàng hóa",
    Variant: "Biến thể hàng hóa",
    Fields: "Trường định danh",
    WarehouseManagement: "Quản lý kho",
    Import: "Nhập kho",
    Export: "Xuất kho",
    Reports: "Báo cáo",
    Field: "Trường định danh",
    History: "Lịch sử",
    Goods: "Quản lý hàng hóa",
    User: "Quản lý người dùng",
    Partner: "Quản lý đối tác",
    CustomerProfile: "Hồ sơ khách hàng",
    System: "Quản lý hệ thống",
    Configuration: "Cấu hình",
    ErrorCode: "Cấu hình mã lỗi",
    Role: "Phân quyền",
    Permission: "Quyền truy cập",
    Feature: "Tính năng",
    BalanceTicket: "Hạn mức",
    SupplierFeature: "Tính năng nhà cung cấp",
    Loading: "Loading (thử nghiệm)",
    File: "Tệp tin",
    DeliveryService: "Đơn vị vận chuyển",
    TransactionWarehouse: "Báo cáo giao dịch kho",
    PartnerKey: "Khóa đối tác",
    NiceSim: "SIM số đẹp",
  },
  //Generals Feature
  Generals: {
    Chart: "Dạng đồ thị",
    Table: "Dạng bảng",
    Disconnected: "Không có dữ liệu để hiển thị biểu đồ",
    StoragesReport: {
      Label: "Giao dịch Kho - Ngăn kho",
      DataType: "Dữ liệu giao dịch",
      Message: {
        Error: "Lỗi lấy dữ liệu",
      },
      Placeholder: "Vui lòng chọn kho",
      ChartLabels: {
        FinalTotalItem: "Tổng sản phẩm hiện có",
        FinalTotalPrice: "Tổng giá trị sản phẩm",
        FinalTotalItemImport: "Số lượng sản phẩm tồn kho",
        FinalTotalPriceImport: "Tổng giá trị sản phẩm tồn kho",
        FinalTotalItemExport: "Số lượng sản phẩm đã bán",
        FinalTotalPriceExport: "Tổng giá trị sản phẩm đã bán",
      },
      YAxis: {
        Products: "Hàng hóa",
      },
    },
    TransactionReport: {
      Label: "Giao dịch theo tháng",
      ChartLabels: {
        Total: "Tổng doanh thu",
        MonthlyImport: "Giao dịch nhập các tháng",
        MonthlyExport: "Giao dịch xuất các tháng",
        Products: "Sản phẩm",
        TotalProducts: "Tổng sản phẩm",
        TotalRevenue: "Tổng doanh thu",
      },
    },
    WalletTransaction: {
      CardTitle: "Giao dịch sản phẩm",
      Labels: {
        Name: "Tên sản phẩm",
        Code: "Mã sản phẩm",
        Total: "Giao dịch",
        QuantityFinished: "Giao dịch hoàn thành",
        QuantityError: "Giao dịch lỗi",
        Revenue: "Doanh thu",
        RatioError: "Tỷ lệ lỗi",
        TotalRatioError: "Tổng tỷ lệ lỗi",
        Category: "Loại hàng hóa ( cho danh sách sản phẩm )",
        Variants: "Danh sách biến thể ( mã sản phẩm )",
        ProductTotal: "Tổng sản phẩm",
      },
      ObjectLabels: {
        total: "Tổng giao dịch",
        totalRevenue: "Tổng doanh thu",
        totalQuantityFinished: "Tổng giao dịch hoàn thành",
        totalQuantityError: "Tổng giao dịch lỗi",
        totalRatioError: "Tổng tỷ lệ lỗi (%)",
      },
    },
    PartnerTransactions: {
      CardTitle: "Giao dịch đối tác theo tháng",
    },
  },
  //Variants Management
  VariantManagement: {
    CardTitle: "Danh sách biến thể",
    TotalVariants: "Tổng biến thể",
    InventoryItems: "Danh sách hàng hóa",
    Inventories: "Danh sách ngăn kho",
    Columns: {
      CreatedAt: "Thời gian tạo",
      Name: "Tên",
      Code: "Mã",
      Sku: "Mã SKU",
      Quantity: "Tổng hàng",
      Price: "Giá tiền",
      Order: "Order",
      Type: "Loại",
      Note: "Ghi chú",
      Status: "Trạng thái",
    },
    InventoryItemsColumns: {
      Name: "Tên hàng hóa",
      Code: "Mã hàng hóa",
      Status: "Trạng thái",
      Unit: "Đơn vị tính",
    },
    Filters: {
      Category: "Loại hàng hóa",
      GroupCategory: "Nhóm hàng hóa",
    },
    Currency: {
      price: "Giá tiền",
      quantity: "Tổng hàng",
      created: "Thời gian tạo",
    },
    RuleMessage: {
      Name: "Tên biến thể không để trống !",
      Sku: "Mã SKU không để trống !",
      Code: "Mã biến thể không để trống !",
      Type: "Vui lòng chọn loại biến thể !",
      Status: "Vui lòng chọn trạng thái !",
      Price: "Vui lòng định giá tiền",
      Quantity: "Vui lòng nhập số lượng !",
      GroupCategory: "Vui lòng chọn nhóm hàng hóa",
      Category: "Vui lòng chọn loại hàng hóa",
      ProductType: "Vui lòng chọn mẫu hàng",
      Supplier: "Vui lòng chọn nhà cung cấp",
      InvalidCategoryName: "Vui lòng đặt tên giống với tên loại hàng hóa !",
    },
    Placeholder: {
      Name: "Nhập tên biến thể...",
      Sku: "Nhập mã sku...",
      Code: "Nhập mã biến thể...",
      Type: "Chọn loại biến thể",
      Status: "Chọn trạng thái biến thể",
      Description: "Nhập mô tả...",
      InvalidCategory: "Vui lòng chọn nhóm hàng hóa để hiện loại hàng hóa",
      Goods: "Chọn hàng hóa",
    },
  },
  //Export Products Feature
  ExportProducts: {
    CardTitle: "Xuất Kho",
    Title: "Xuất/Chuyển kho",
    Transfer: "Chuyển kho",
    Destroy: "Xuất hủy hàng",
    Message: {
      PartnerWithNoWallet: `Lỗi xuất kho : Đối tác không có ví !`,
      ExportError: "Lỗi xuất kho !",
      ExportSuccess: "Xuất kho thành công !",
      TransferSuccess: "Chuyển kho thành công !",
      TransferError: "Lỗi chuyển kho",
      PickAStorage: "Vui lòng chọn một kho",
      DestroySuccess: "Xuất hủy thành công",
      DestroyFailed: "Xuất hủy thất bại",
      Category: "Chọn loại hàng hóa để cập nhật hàng hóa",
      InvalidItems: "Ngăn kho hiện tại không có hàng để xuất",
      Exporting: "Đang xuất",
      Transfering: "Đang chuyển",
    },
    Columns: {
      ProductColumns: {
        Name: "Tên hàng hóa",
        Code: "Mã hàng hóa",
        Status: "Trạng thái",
        UpdatedAt: "Ngày cập nhật",
        CreatedAt: "Ngày tạo",
        Inventory: "Thông tin ngăn kho chứa hàng hóa",
        InvetoryName: "Tên ngăn",
        InventoryCode: "Mã ngăn",
        InventoryQuantity: "Tổng hàng trong ngăn",
        Warehouse: "Thông tin kho cha của ngăn",
        WarehouseName: "Tên kho",
        WarehouseCode: "Mã kho",
      },
    },
    TourGuides: {
      Warehouse: "Chọn kho",
      WarehouseMessage: "Chọn kho để lấy danh sách ngăn kho của kho đó",
      Inventory: "Chọn ngăn kho",
      InventoryMessage:
        "Chọn ngăn kho để lấy danh sách sản phẩm bên dưới. Kho và ngăn kho ở đây sẽ là Kho xuất và Ngăn kho xuất ở mục Xuất kho và Chuyển kho !",
    },
    Labels: {
      ProductList: "Sản phẩm trong ngăn kho",
      TotalProduct: "Tổng sản phẩm",
      InvalidSelectedProducts: "Chưa có sản phẩm chọn",
      SelectedProducts: "Sản phẩm đã chọn",
      InvalidForExporting: "Vui lòng chọn sản phẩm để xuất",
      InvalidForTransfering: "Vui lòng chọn sản phẩm để chuyển",
      SearchAgain: "Vui lòng nhấn tra cứu để chọn sản phẩm mới",
      Caution: "Lưu ý",
      ImportedWarehouse: "Kho xuất",
      ImportedInventory: "Ngăn kho xuất",
      RecievedSupplier: "Đại lý nhận",
      RecievedWarehouse: "Kho nhận",
      RecievedInventory: "Ngăn kho nhận",
      ProductType: "Mẫu hàng hóa ( vật lý )",
      ExportedDate: "Ngày xuất",
      TransferedDate: "Ngày chuyển",
      TotalNeedToDestroy: "Tổng hàng cần hủy",
    },
    RuleMessage: {
      RecievedWarehouse: "Vui lòng chọn kho nhận",
      InvalidInventory: "Vui lòng chọn kho nhận để hiện ngăn kho",
      RecievedInventory: "Vui lòng chọn ngăn kho nhận ",
      RecievedSupplier: "Vui lòng chọn đại lý nhận",
      ProductType: "Vui lòng chọn mẫu hàng hóa",
      InventoryValid: "Chọn kho để cập nhật ngăn kho",
    },
  },
  //Transaction History
  TransactionHistory: {
    MainLabels: {
      Transactions: "Giao dịch sản phẩm",
      WalletTransaction: "Giao dịch ví đối tác",
      CardTitle: "Lịch sử",
      TransCode: "Mã giao dịch",
      TransDetail: "Chi tiết giao dịch",
    },
    Status: {
      Init: "Khởi tạo",
      Progerssing: "Đang xử lý",
      Finished: "Hoàn thành",
      Error: "Lỗi",
      Deleted: "Đã xóa",
      Delivering: "Đang giao hàng",
      WaitToPurchase: "Chờ thanh toán",
      Pending: "Chưa giải quyết",
    },
    Type: {
      Active: "Kích hoạt giao dịch",
      Import: "Nhập",
      Export: "Xuất",
      Transfer: "Chuyển",
      Kyc: "Đấu nối",
    },
    ExcelMessage: {
      Error: "Lỗi xuất Excel: Có thể danh sách trống hoặc lỗi dữ liệu !",
      EmptyResponse: "Không thể xuất Excel: Danh sách giao dịch trống !",
      TypeRequired: "Vui lòng chọn hình thức giao dịch khác Tất cả",
    },
    Currency: {
      wallet: "Số dư ví trước giao dịch",
      cost: "Số dư ví sau giao dịch",
      shipFee: "Phí vận chuyển",
      totalAmount: "Tổng giao dịch",
    },
    Date: {
      created: "Thời gian tạo",
      payment: "Thời gian thanh toán",
      complete: "Thời gian hoàn thành",
      cancel: "Thời gian hủy",
      ship: "Thời gian vận chuyển",
    },
    Details: {
      Labels: {
        Id: "Mã id",
        Note: "Ghi chú",
        UntilPrice: "Tổng tiền giao dịch",
        Transaction: "Mã tham chiếu",
        Type: "Loại giao dịch",
        Status: "Trạng thái giao dịch",
        Quantity: "Số lượng hàng giao dịch",
        TimeExce: "Thời gian thực hiện",
        BeforeQuantity: "Số lượng hàng trước giao dịch",
        AfterQuantity: "Số lượng hàng sau giao dịch",
        BeforeQuantityInventory: "Số lượng hàng trong ngăn trước giao dịch",
        AfterQuantityInventory: "Số lượng hàng trong ngăn sau giao dịch",
        BeforeQuantityVariant: "Số lượng hàng của biến thể trước giao dịch",
        AfterQuantityVariant: "Số lượng hàng của biến thể sau giao dịch",
        Name: "Tên đối tác",
        Code: "Mã đối tác",
        Wallet: "Tiền trong ví trước giao dịch",
        Cost: "Tiền trong ví sau giao dịch",
        TransactionDetails: "Hàng hóa giao dịch",
        TransactionWalletDetails: "Thông tin ví đối tác",
        TransactionLog: "Log giao dịch",
        ShipFee: "Phí vận chuyển",
        ShippTime: "Ngày vận chuyển",
        CancellationReason: "Lý do hủy đơn",
        CancelledTime: "Ngày hủy đơn",
        CompletedTime: "Ngày hoàn thành",
        DeliveryService: "Dịch vụ vận chuyển",
      },
      NewDetail: {
        createdAt: "Thời gian tạo",
        updatedAt: "Thời gian cập nhật",
        name: "Tên",
        code: "Mã",
        transRef: "Mã tham chiếu",
        merchant: "Đối tác",
        type: "Loại",
        status: "Trạng thái",
        inner: "Khu vực",
        cost: "Số dư ví sau giao dịch",
        totalAmount: "Tổng tiền",
        shipFee: "Phí vận chuyển",
        wallet: "Số dư ví trước giao dịch",
        paymentTime: "Thời gian thanh toán",
        shipTime: "Thời gian vận chuyển",
        completedTime: "Thời gian hoàn thành",
        cancelledTime: "Thời gian hủy",
        cancellationReason: "Lý do hủy",
        deliveryService: "Đơn vị vận chuyển",
        customerProfile: "Hồ sơ khách hàng",
        note: "Ghi chú",
      },
      CustomerProfile: {
        fullName: "Tên đầy đủ",
        profileId: "Mã hồ sơ",
        referenceId: "Mã tham chiếu đối tác",
        status: "Trạng thái",
        type: "Loại",
      },
      LogQuantityCol: {
        Before: "Trước giao dịch",
        After: "Sau giao dịch",
      },
    },
    Columns: {
      PartnerTransactionDetailChild: {
        Transaction: "Mã tham chiếu",
        UntilPrice: "Tổng tiền",
        Quantity: "Số sản phẩm",
        Type: "Hình thức",
        TransactionStatus: "Loại giao dịch",
        TimeExce: "Thời gian giao dịch",
      },
      WarehouseTransactionItems: {
        WarehouseName: "Tên kho",
        WarehouseCode: "Mã kho",
      },
      DetailItemsColumns: {
        ItemName: "Tên hàng hóa",
        ItemCode: "Mã hàng hóa",
        ItemStatus: "Trạng thái",
        ItemPrice: "Giá hàng hóa (VND)",
        ItemQuantity: "Số lượng hàng",
        ItemUnit: "Đơn vị",
        ItemCover: "Hình ảnh",
      },
      Transaction: {
        Name: "Tên giao dịch",
        Code: "Mã giao dịch",
        Type: "Loại giao dịch",
        PartnerTransactionDetail: "Thông tin giao dịch đối tác",
        WarehouseTransactionItems: "Thông tin kho giao dịch",
        Cost: "Giá trị giao dịch",
        TotalAmount: "Tổng tiền",
      },
      MainColumns: {
        createdAt: "Thời gian tạo",
        name: "Tên",
        salesPhoneNumber: "Số thuê bao",
        code: "Mã",
        transRef: "Mã tham chiếu",
        type: "Loại",
        deliveryTransactionStatus: "Trạng thái đơn",
        status: "Trạng thái giao dịch",
        note: "Ghi chú",
        totalAmount: "Tổng tiền",
        wallet: "Số dư ví trước giao dịch",
        cost: "Số dư ví sau giao dịch",
        merchant: "Đối tác",
      },
      WalletTransaction: {
        Code: "Mã giao dịch",
        Note: "Ghi chú",
        PhoneNumber: "Số điện thoại",
        Duration: "Ngày",
        Price: "Tổng tiền",
        Name: "Tên sản phẩm",
        SupplierResponseCode: "Mã trạng thái",
        SupplierDescription: "Ghi chú nhà cung cấp",
        SupplierTransId: "Mã giao dịch nhà cung cấp",
        PartnerBuy: "Đối tác giao dịch",
        Transaction: "Mã tham chiếu",
      },
    },
    Filters: {
      Code: "Mã giao dịch",
      TransRef: "Mã tham chiếu",
      Type: "Hình thức giao dịch",
      TransactionType: "Loại giao dịch",
      TransactionReports: "Xuất báo cáo giao dịch",
      WalletTransactionReports: "Xuất báo cáo ví",
      TransId: "Mã tham chiếu nhà cung cấp",
    },
    Placeholder: {
      Code: "Nhập mã giao dịch...",
      TransRef: "Nhập mã tham chiếu...",
      Phone: "Nhập số điện thoại...",
      Warehouse: "Vui lòng chọn kho",
      SwitchCol: {
        name: "Xem số thuê bao",
        salesPhoneNumber: "Xem tên giao dịch",
        code: "Xem mã tham chiếu",
        transRef: "Xem mã giao dịch",
      },
    },
  },
  //Products Management
  ProductsManagement: {
    CardTitle: "Danh sách hàng hóa",
    Total: "Tổng hàng hóa",
    Columns: {
      Name: "Tên hàng hóa",
      Code: "Mã hàng hóa",
      ShortDes: "Mô tả ngắn",
      Supplier: "Nhà cung cấp",
    },
    Details: {
      ProductLabels: {
        CardTitle: "Thông tin hàng hóa",
        Name: "Tên hàng hóa",
        Code: "Mã hàng hóa",
      },
      InventoryLabels: {
        CardTitle: "Thông tin ngăn kho của hàng hóa",
        Name: "Tên ngăn kho",
        Code: "Mã ngăn kho",
        Quantity: "Số lượng",
      },
      VariantsInGoods: {
        Name: "Tên biến thể",
        Code: "Mã biến thể",
        Sku: "Mã SKU",
        Quantity: "Tổng hàng",
        Price: "Giá tiền",
      },
      FieldsInGoods: {
        Title: "Danh sách trường định danh",
        Name: "Tên trường",
        Code: "Mã trường",
        Important: "Quan trọng",
        IsImportant: "Quan trọng",
        NotImportant: "Không quan trọng",
      },
      Message: {
        Category: "Không thể cập nhật Loại hàng hóa vì hàng đã có Biến thể",
        Type: "Không thể cập nhật loại vì hàng đã có Biến thể",
        Field: "Không thể cập nhật Trường định danh vì hàng đã có Biến thể",
        CannotDelete: "Không thể xóa hàng hóa này vì hàng đã có Biến thể",
        ChooseType: "Chọn loại để cập nhật danh sách Trường định danh",
        Supplier: "Không thể cập nhật Nhà cung cấp vì hàng đã có Biến thể",
      },
    },
  },
  //Categories Management
  CategoriesManagement: {
    CardTitle: "Danh sách loại hàng hóa",
    Columns: {
      createdAt: "Thời gian tạo",
      Name: "Tên",
      Code: "Mã",
      Type: "Loại",
      Status: "Trạng thái",
      Order: "Order",
      Description: "Mô tả",
    },
    Details: {
      Name: "Tên loại",
      Code: "Mã loại",
      Type: "Loại của hàng hóa",
      Description: "Mô tả",
      Parent: "Loại hàng hóa nhóm",
      Cover: "Link hình ảnh",
      GoodsInCategory: {
        Name: "Tên hàng hóa",
        Code: "Mã hàng hóa",
      },
    },
    Placeholder: {
      Parent: "Vui lòng chọn loại hàng hóa nhóm",
    },
    RuleMessage: {
      Name: "Tên loại không để trống !",
      Code: "Mã loại không để trống !",
      Status: "Vui lòng chọn trạng thái",
      Type: "Vui lòng chọn loại",
      CannotUpdate:
        "Hiện tại hệ thống chưa cho phép cập nhật loại hàng hóa nhóm !",
      Cover: "Vui lòng nhập link hình ảnh dạng url HTTPS",
    },
  },
  //Product Fields Management
  ProductFieldsManagement: {
    CardTitle: "Danh sách thuộc tính",
    Labels: {
      Name: "Khóa thuộc tính",
      Value: "Tên thuộc tính",
      Type: "Loại thuộc tính",
      Id: "ID thuộc tính",
    },
    Placeholder: {
      Name: "Nhập khóa thuộc tính",
      Value: "Nhập tên thuộc tính",
      Type: "Chọn loại thuộc tính",
    },
    RuleMessage: {
      Id: "ID thuộc tính không để trống !",
      Name: "Khóa thuộc tính không để trống !",
      Value: "Tên thuộc tính không để trống !",
      Type: "Loại thuộc tính không để trống !",
    },
  },
  //Storages Management
  StoragesManagement: {
    CardTitle: "Kho",
    Total: "Tổng số kho",
    InventoryInfo: "Thông tin ngăn kho",
    AddInventory: "Thông tin ngăn kho",
    AddVariant: "Thông tin biến thể",
    Columns: {
      Name: "Tên kho",
      Code: "Mã kho",
      Capacity: "Ngăn kho tối đa",
      MaxInventory: "Ngăn kho tối đa",
      Parent: "Kho cha",
      ProductsInInventory: "Hàng hóa trong ngăn",
      ProductList: "Danh sách hàng hóa",
      WalletName: "Tên ví",
      WalletCode: "Mã ví",
      Owner: "Chủ kho",
      Quantity: "Tổng hàng hóa",
    },
    Placeholder: {
      Warehouse: "Nhập mã kho",
      Parent: "Chọn kho cha ( để trống nếu đang tạo kho cha )",
    },
    RuleMessage: {
      Capacity: "Vui lòng nhập số lượng ít nhất 10",
      Name: "Tên kho không để trống !",
      Code: "Mã kho không để trống !",
      NoPhyInven:
        "Kho đang chọn không có ngăn kho vật lý, vui lòng chọn kho khác",
    },
  },
  //Inventories Management
  InventoriesManagement: {
    Placeholder: {
      Sku: "Chọn loại hàng hóa để hiện danh sách",
    },
    RuleMessage: {
      Sku: "Vui lòng chọn mã Sku",
      Name: "Tên ngăn không để trống !",
      Code: "Mã ngăn không để trống !",
      Type: "Vui lòng chọn loại ngăn",
      Goods: "Chọn biến thể để hiện thông tin hàng hóa",
      InventoryType:
        "Loại sẽ phụ thuộc vào loại biến thể đã chọn, loại Online sẽ không thể tùy chọn loại cho ngăn kho",
    },
    Labels: {
      Storage: "Kho",
      Name: "Tên ngăn",
      Code: "Mã ngăn",
      Type: "Loại ngăn",
      Total: "Tổng ngăn kho",
      TotalProducts: "Tổng hàng trong ngăn",
      CurrentBalance: "Hạn mức hiện tại",
      MaxBalance: "Hạn mức tối đa",
      ItemsInInventory: {
        Name: "Tên sản phẩm",
        Code: "Mã sản phẩm",
        Total: "Tổng sản phẩm trong ngăn",
        ModalTitle: "Sản phẩm trong ngăn",
      },
    },
  },
  //Partners Management
  PartnersManagement: {
    Labels: {
      Name: "Tên đối tác",
      Code: "Mã đối tác",
      Type: "Loại đối tác",
      DisplayName: "Tên hiển thị",
      WarehouseInfo: "Thông tin kho",
      WalletInfo: "Thông tin ví",
      PartnerWallets: "Thông tin ví đối tác",
      WalletTransaction: "Lịch sử giao dịch ví",
      PartnerWarehouses: "Thông tin kho thuộc đối tác",
      Balance: "Số dư",
      Key: "Khóa định danh đối tác",
      PartnerKey: "Khóa đối tác",
      AccountHolderName: "Chủ tài khoản",
      AccountBankName: "Tên tài khoản",
      AccountBankAccount: "Số tài khoản",
      AccountBankExpireDate: "Ngày hết hạn",
    },
    RuleMessage: {
      Name: "Tên đối tác không để trống !",
      Code: "Mã đối tác không để trống !",
      Phone: "Số điện thoại không để trống !",
      Fax: "Số fax không để trống !",
      Email: "Email không để trống !",
      Address: "Địa chỉ không để trống !",
      Type: "Chọn loại cho đối tác",
      DisplayName: "Vui lòng nhập tên hiển thị !",
    },
  },
  //Products Import Feature
  Import: {
    Columns: {
      ProductTypeName: "Tên mẫu hàng",
      ProductTypeCode: "Mã mẫu hàng",
    },
    Labels: {
      GetImportFile: "Lấy mẫu file nhập",
      RemoveAll: "Làm mới",
      Import: "Nhập kho",
      ImportedInventory: "Ngăn kho nhập",
      ImportedDate: "Ngày nhập",
      ProductTypeList: "Danh sách mẫu hàng hóa",
      TotalProductType: "Tổng số lượng mẫu hàng",
      ProductType: "Mặt hàng nhập",
      NeedDivide: "Chia sản phẩm",
      Products: "Kiểu hàng",
      Ratio: "Tỷ lệ chia",
      StraightImport: "Nhập từ Excel",
      RequestImport: "Yêu cầu đơn nhập",
      DataCodeCard: "Thẻ Data Code",
      SimCombo: "SIM Combo",
      TravelSim: "SIM Du lịch",
      ECommerce: "SIM TMDT",
      Serial: "Số Serial",
      PhoneNumber: "Số Điện Thoại",
      Yes: "Có",
      No: "Không",
      Sms: "Nạp SMS",
      StraightMessage: "Nạp trực tiếp",
      SuccessImportResult: "Danh sách hàng nhập kho thành công",
      ErrorImportResult: "Danh sách hàng nhập kho thất bại",
    },
    Message: {
      ImportedSuccessfully: "Nhập kho thành công",
      ImportedFailed: "Lỗi nhập kho",
      DownloadedSuccessfully: "Tải file mẫu thành công",
      DownloadedFailed: "Lỗi tải file",
      NeedItems: "Vui lòng thêm danh sách hàng hóa yêu cầu",
      RequestSuccessfully:
        "Yêu cầu đơn hàng thành công, đang kích hoạt đơn, vui lòng đợi !",
      ActiveSuccessfully:
        "Kích hoạt đơn hàng thành công, kiểm tra email để nhận template nhập kho !",
      NeedGoods: "Vui lòng chọn hàng hóa",
      NeedGoodsToUpdate:
        "Vui lòng chọn hàng hóa để cập nhật danh sách biến thể",
      NeedSupplier: "Vui lòng chọn nhà cung cấp",
      FoundTransCode:
        "Tra cứu mã giao dịch thành công, đã kích hoạt đơn nhập !",
    },
    Placeholder: {
      Supplier: "Vui lòng chọn nhà cung cấp",
      Warehouse: "Vui lòng chọn kho",
      Inventory: "Vui lòng chọn ngăn kho nhập",
      DocumentLicense: "Vui lòng nhập mã chứng từ",
      ProductType: "Vui lòng chọn mẫu hàng ( áp dụng cho mẫu vật lý )",
      ChoseFiles: "Vui lòng chọn file nhập từ thiết bị",
      InvalidInventory: "Vui lòng chọn kho để hiện ngăn kho",
      Category: "Vui lòng chọn loại hàng hóa",
    },
    FinalItemsSuccess: {
      createdAt: "Thời gian tạo",
      updatedAt: "Thời gian cập nhật",
      name: "Tên",
      code: "Mã",
      serial: "Mã Serial",
      status: "Trạng thái",
      type: "Loại",
      inventory: "Ngăn kho",
      variant: "Biến thể",
      price: "Tổng tiền",
      connectedTime: "Thời gian đấu nối",
      activatedTime: "Thời gian kích hoạt",
      description: "Mô tả",
    },
    FinalItemError: {
      serial: "Mã Serial",
      errorCode: "Mã lỗi",
      errorMessage: "Nội dung",
    },
  },
  FieldManagement: {
    Title: "Trường định danh",
    Columns: {
      Name: "Tên",
      Code: "Mã",
      IsImportant: "Tính quan trọng",
    },
  },
  UserManagement: {
    Title: "Người dùng",
    Columns: {
      Username: "Tên tài khoản",
      Role: "Vai trò",
    },
    Message: {
      Role: "Vui lòng chọn role",
    },
  },
  Authentication: {
    Login: {
      Noti: "Nhập tài khoản và mật khẩu để đăng nhập",
    },
  },
  CustomerProfileManagement: {
    Columns: {
      FullName: "Họ tên",
      ProfileId: "Mã hồ sơ",
      ReferenceId: "Mã tham chiếu đối tác",
      ReferenceNote: "Ghi chú tham chiếu",
      Passport: "Hộ chiếu",
      Identification: "CCCD",
    },
    Message: {
      ProfileId: "Vui lòng nhập mã hồ sơ",
      ReferenceId: "Vui lòng nhập mã đối tác",
    },
    Detail: "Thông tin hồ sơ",
    CCCD: "Số CCCD",
    ProfilDetail: {
      birthDay: "Ngày sinh",
      idNumber: "Số hộ chiếu",
      name: "Họ và tên",
      address: "Địa chỉ",
      placeOfOrigin: "Quê quán",
      nationality: "Quốc tịch",
      issueDate: "Ngày cấp",
      issuePlace: "Nơi cấp",
    },
  },
  ItemsManagement: {
    Label: "Hàng tồn kho",
    Transaction: "Mã giao dịch",
    TransTable: "Lịch sử giao dịch",
    MSaleTitle: "SIM M-Sale vừa nhập",
    MSaleImport: "Nhập SIM M-Sale",
    MSale: {
      serial: "Mã serial",
      bookingCode: "Mã giữ chỗ",
    },
    Columns: {
      Name: "Tên hàng",
      Code: "Mã hàng",
      Serial: "Mã Serial",
      ConnectedTime: "Thời gian đấu nối",
    },
    Status: {
      0: "Nhập",
      1: "Xuất",
      2: "Đã đấu nối",
      3: "Đã kích hoạt",
      4: "Đã hủy",
      5: "Đã giữ",
    },
    Detail: {
      createdAt: "Thời gian tạo",
      updatedAt: "Thời gian cập nhật",
      connectedTime: "Thời gian đấu nối",
      activatedTime: "Thời gian kích hoạt",
      name: "Tên",
      code: "Mã",
      serial: "Mã Serial",
      type: "Loại",
      status: "Trạng thái",
      description: "Ghi chú",
      inventory: "Ngăn kho",
      variant: "Biến thể",
      buyedDate: "Ngày mua",
      expirationDate: "Ngày hết hạn",
    },
    Transactions: {
      name: "Tên",
      code: "Mã",
      transRef: "Mã tham chiếu",
      totalAmount: "Tổng tiền",
      status: "Trạng thái",
    },
    Message: {
      EmptyMSale: "Không có SIM M-Sale đã nhập !",
      ImportMSaleSuccessfully: "Nhập SIM M-Sale thành công !",
      TotalMSale: "Tổng SIM M-sale",
    },
  },
  Transfer: {
    MainTitle: "Chuyển kho",
    Labels: {
      fromStorage: "Kho đi",
      fromInventory: "Ngăn kho đi",
      toStorage: "Kho đến",
      toInventory: "Ngăn kho đến",
      quantity: "Số lượng cần chuyển",
    },
    Message: {
      InvalidFromInventory:
        "Kho đi không có ngăn Physical hoặc Direct Physical, vui lòng chọn kho khác",
      InvalidToInventory:
        "Kho đến không có ngăn Physical hoặc Direct Physical, vui lòng chọn kho khác",
      ChooseStorage: "Chọn kho để lấy danh sách ngăn kho",
    },
  },
  WalletManagement: {
    MainTitle: "Ví đối tác",
    Columns: {
      CreatedAt: "Thời gian tạo",
      Name: "Tên ví",
      Code: "Mã ví",
      Balance: "Số dư",
      Type: "Loại ví",
      Status: "Trạng thái",
      Note: "Ghi chú",
      Primary: "Ví ưu tiên",
      Caculate: "Dùng cho giao dịch",
      Postpaid: "Có trả sau",
      Owner: "Chủ ví",
    },
    MainColumns: {
      createdAt: "Thời gian tạo",
      name: "Tên",
      code: "Mã",
      balance: "Số dư",
      status: "Trạng thái",
      isPrimary: "Ưu tiên",
      isCaculate: "Trừ số dư",
      isPostpaid: "Trả sau",
      order: "Order",
      note: "Ghi chú",
    },
  },
  ConfigurationManagement: {
    Title: "Quản lý cấu hình",
    Columns: {
      createdAt: "Thời gian tạo",
      key: "Từ khóa",
      order: "Order",
    },
    Message: {
      Key: "Vui lòng nhập từ khóa",
      Value: "Vui lòng khai báo cấu hình",
    },
  },
  ErrorCodeManagement: {
    Title: "Quản lý mã cấu hình lỗi",
    Columns: {
      createdAt: "Thời gian tạo",
      code: "Mã",
      message: "Nội dung",
      order: "Order",
      type: "Loại",
    },
    Message: {
      Code: "Vui lòng nhập mã lỗi",
      Message: "Vui lòng nhập nội dung",
    },
  },
  RoleManagement: {
    Title: "Quản lý phân quyền",
    Columns: {
      createdAt: "Thời gian tạo",
      name: "Tên",
      code: "Mã",
      quantity: "Người dùng tối đa",
      status: "Trạng thái",
    },
    Message: {
      Quantity: "Vui lòng nhập số lượng người dùng",
    },
    Currency: {
      created: "Thời gian tạo",
      quantity: "Người dùng tối đa",
    },
  },
  PermissonManagement: {
    Title: "Quản lý quyền truy cập",
    Columns: {
      createdAt: "Thời gian tạo",
      name: "Tên",
      code: "Mã",
      user: "Người dùng",
      path: "Đường dẫn",
      order: "Order",
      status: "Trạng thái",
    },
    Action: {
      user: "Người dùng",
      feature: "Tính năng cho phép",
    },
    Message: {
      User: "Vui lòng chọn người dùng",
      Feature: "Vui lòng chọn ít nhất một tính năng",
    },
  },
  FeatureManagement: {
    Title: "Quản lý tính năng",
    ResetFeature: "Làm mới danh sách tính năng của tài khoản",
    Users: "Danh sách người dùng sử dụng",
    Columns: {
      createdAt: "Thời gian tạo",
      name: "Tên",
      code: "Mã",
      path: "Đường dẫn",
      order: "Order",
      status: "Trạng thái",
    },
    Actions: {
      name: "Tên",
      code: "Mã",
      path: "Đường dẫn",
      status: "Trạng thái",
    },
    Message: {
      name: "Vui lòng nhập tên",
      code: "Vui lòng nhập mã",
      path: "Vui lòng nhập đường dẫn",
      status: "Vui lòng chọn trạng thái",
    },
  },
  ActionLogManagement: {
    Title: "Action logs",
    Users: "Thông tin người dùng",
    Columns: {
      createdAt: "Thời gian tạo",
      code: "Mã",
      path: "Đường dẫn",
      user: "Người dùng",
    },
    Details: {
      createdAt: "Thời gian tạo",
      updatedAt: "Thời gian cập nhật",
      code: "Mã",
      path: "Đường dẫn",
      user: "Người dùng",
      status: "Trạng thái",
      preData: "Pre Data",
      afterData: "After Data",
    },
  },
  BalanceTicketManagement: {
    Columns: {
      createdAt: "Thời gian tạo",
      name: "Tên",
      code: "Mã",
      type: "Loại",
      money: "Số tiền",
      beforeBalanceFromWallet: "Số dư ví nguồn trước duyệt",
      afterBalanceFromWallet: "Số dư ví nguồn sau duyệt",
      beforeBalanceToWallet: "Số dư ví đích trước duyệt",
      afterBalanceToWallet: "Số dư ví đích sau duyệt",
      order: "Order",
      status: "Trạng thái",
    },
    Filters: {
      name: "Tên",
      code: "Mã",
      type: "Loại",
      status: "Trạng thái",
      createdBy: "Người tạo",
      verifiedBy: "Người duyệt",
      fromWallet: "Ví nguồn",
      toWallet: "Ví đích",
    },
    Actions: {
      name: "Tên",
      code: "Mã",
      fromWallet: "Ví nguồn",
      toWallet: "Ví đích",
      type: "Loại",
    },
    Others: {
      name: "Tên",
      code: "Mã",
      type: "Loại",
      status: "Trạng thái",
      username: "Tên tài khoản",
      balance: "Số dư",
    },
    Type: {
      0: "Phiếu gửi",
      1: "Phiếu rút",
      2: "Phiếu chuyển",
    },
    Status: {
      0: "Khởi tạo",
      1: "Đang xử lý",
      2: "Đã duyệt",
      3: "Lỗi",
      4: "Đã xóa",
    },
  },
  SupplierFeatureManagement: {
    Labels: {
      Feature: "Tính năng",
      Package: "Gói cước",
      ClientId: "Mã giao dịch",
      OrderId: "ID đơn hàng",
    },
    Service: {
      Mobifone: {
        "check-transaction": "Kiểm tra giao dịch",
        "check-list-package": "Kiểm tra danh sách gói cước",
        "ingest-msale": "Nhập SIM MSale",
        "check-order-balance": "Kiểm tra hạn mức",
        "check-registration-conditions-package":
          "Kiểm tra điều kiện đăng ký gói cho thuê bao",
      },
      Vmg: {
        "check-data-code-card": "Kiểm tra thẻ Data Code",
      },
    },
  },
  TransactionWarehouse: {
    Statistical: "Thống kê",
    Report: "Báo cáo",
  },
  DeliveryService: {
    Configuration: "Cấu hình",
    Columns: {
      createdAt: "Thời gian tạo",
      updatedAt: "Thời gian cập nhật",
      name: "Tên",
      code: "Mã",
      billCode: "Mã vận đơn",
      deliveryTransID: "Mã vận chuyển tham chiếu",
      defaultBackupFee: "Phí giao hàng mặc định",
      innerFee: "Phí giao hàng nội thành",
      suburbFee: "Phí giao hàng ngoại thành",
      status: "Trạng thái",
      order: "Order",
      description: "Mô tả",
    },
    Message: {
      name: "Vui lòng nhập tên",
      code: "Vui lòng nhập mã",
      description: "Vui lòng nhập mô tả",
      status: "Vui lòng chọn trạng thái",
      fee: "Giá tiền phải có giá trị ít nhất 0 VND",
    },
  },
  PartnerKeyManagemnt: {
    Key: "Khóa định danh",
    CurrentKey: "Khóa định danh hiện tại",
    Columns: {
      createdAt: "Thời gian tạo",
      name: "Tên",
      code: "Mã",
      status: "Trạng thái",
      description: "Mô tả",
      order: "Order",
    },
    Details: {
      name: "Tên",
      code: "Mã",
      status: "Trạng thái",
      partner: "Đối tác",
      description: "Mô tả",
    },
  },
  SupplierImports: {
    Labels: {
      Request: "Lập đơn nhập kho",
      Active: "Kích hoạt đơn - Nhập kho",
      MainLabel: "Nhập theo đơn nhà cung cấp",
      ActiveOrder: "Kích hoạt đơn",
      ReActiveOrder: "Kích hoạt đơn khác",
    },
    ImportResults: {
      createdAt: "Thời gian tạo",
      updatedAt: "Thời gian cập nhật",
      name: "Tên",
      code: "Mã",
      status: "Trạng thái",
      type: "Loại",
      wallet: "Số dư ví trước giao dịch",
      cost: "Số dư ví sau giao dịch",
      responseType: "ResponseType",
      partner: "Đối tác",
    },
    Message: {
      Requesting: "Đang tạo đơn...",
      Activating: "Đang kích hoạt đơn...",
      NotFoundTransRef:
        "Không tìm thấy mã tham chiếu nhà cung cấp, vui lòng thử lại !",
      FoundTransRef:
        "Đã tìm thấy mã tham chiếu nhà cung cấp, đang kích hoạt đơn",
      RequestSuccessfully:
        "Lập đơn thành công, đã lưu mã giao dịch vào bộ nhớ tạm !",
      ActiveSuccessfully: "Kích hoạt đơn thành công !",
      RequestFailed: "Lập đơn thất bại",
      ActiveFailed: "Kích hoạt đơn thất bại",
    },
  },
  DeliveryOrder: {
    MainLabels: {
      Transaction: "Thông tin giao dịch",
      Sender: "Thông tin người gửi",
      Receiver: "Thông tin người nhận",
      CreateOrder: "Tạo đơn",
      DeliveryLogDetail: "Log vận chuyển",
      OngoingDeliveryOrder: "Đơn vận chuyển cần xử lý",
      AddToCart: "Thêm vào xe hàng",
      RemoveFromCart: "Xóa khỏi xe hàng",
      Cart: "Xe hàng",
      DeliveryOrderDetail: "Chi tiết đơn hàng",
      AutoCreateOder: "Tạo đơn tự động",
      PrintOrder: "In đơn",
      AutoPrintOrder: "In đơn tự động",
      CancelOrder: "Hủy đơn",
      CombinedLabel: "In, hủy đơn tự động",
      ConfirmedCancel: "Xác nhận hủy",
      Reason: "Lý do hủy",
      AutoCancelOrder: "Hủy đơn tự động",
      NoOngoingDeliveryOrder: "Chưa có thông tin đơn cần xử lý",
      Progress: "Quy trình xử lý đơn",
      PDF: "Lấy file PDF",
      create: "tạo đơn",
      print: "in đơn",
      cancel: "hủy đơn",
    },
    Status: {
      Init: "Khởi tạo",
      Ongoing: "Đang hiện hành",
      Canceled: "Đã hủy",
    },
    CreateDetail: {
      transaction: "Mã giao dịch",
      deliveryService: "Dịch vụ vận chuyển",
      remark: "Ghi chú",
      sender: {
        senderName: "Họ và tên",
        senderPhoneNumber: "Số điện thoại",
        senderAddress: "Địa chỉ",
        senderArea: "Phường xã",
        senderCity: "Quận huyện",
        senderProvince: "Tỉnh thành",
      },
      receiver: {
        receiverName: "Họ và tên",
        receiverPhoneNumber: "Số điện thoại",
        receiverAddress: "Địa chỉ",
        receiverArea: "Phường xã",
        receiverCity: "Quận huyện",
        receiverProvince: "Tỉnh thành",
      },
      itemName: "Tên hàng hóa",
      itemEnglishName: "Tên hàng hóa tiếng Anh",
      itemQuantity: "Số lượng hàng",
      itemValue: "Giá tiền",
    },
    CreateSucessError: {
      Transaction: "Mã giao dịch",
      BillCode: "Mã vận đơn",
      DeliveryTransId: "Mã vận chuyển tham chiếu",
    },
    Message: {
      CreateSuccessfully: "Tạo đơn thành công",
      CreateFailed: "Tạo đơn thất bại",
      OrderInCart: "Trong xe hàng",
      CreatingOrder: "Đang tạo đơn",
      Processing: "Đang xử lý",
      ConfirmPrinted: "Xác nhận in đơn cho",
      ConfirmedCancel: "Xác nhận hủy",
      PrintSuccessfully: "In đơn thành công",
      PrintFailed: "In đơn thất bại",
      CancelSucessfully: "Hủy đơn thành công",
      CancelFailed: "Hủy đơn thất bại",
      NoCreatePermission: "Chưa được cấp quyền tạo đơn",
      NoPrintAndCancelPermission: "Chưa được cấp quyền in, hủy đơn",
      ConfirmedForSingleCancel: "Xác nhận hủy đơn cho giao dịch",
      GetDeliveryOrderFailed: "Lấy chi tiết đơn hàng thất bại",
    },
  },
  NiceSimManagement: {
    Columns: {
      code: "Mã SIM",
      phoneNumber: "Số SIM",
      serial: "Mã Serial",
      format: "Định dạng số SIM",
      package: "Gói cước",
      price: "Giá tiền",
      destiny: "Mệnh phong thủy",
      numerology: "Thần số học",
      zodiac: "Cung hoàng đạo",
    },
    NiceSimVariants: {
      ALL: "Tất cả",
      MEMORABLE_PHYSICAL: "Số dễ nhớ",
      FENG_SHUI_PHYSICAL: "Số phong thủy",
      EVEN_PHYSICAL: "Số chẵn - lẻ",
      FOUR_KIND_PHYSICAL: "Số tứ quý",
      THREE_NUMBER_PHYSICAL: "Số tam cô",
      HALL_PHYSICAL: "Số sảnh",
    },
    Filters: {
      code: "Mã SIM",
      phoneNumber: "Số điện thoại",
      goods: "Hàng hóa",
    },
    FengShui: ["Kim", "Mộc", "Thủy", "Hỏa", "Thổ"],
    Zodiac: [
      "Bạch Dương",
      "Kim Ngưu",
      "Song Tử",
      "Cự Giải",
      "Sư Tử",
      "Xử Nữ",
      "Thiên Bình",
      "Bọ Cạp",
      "Nhân Mã",
      "Ma Kết",
      "Bảo Bình",
      "Song Ngư",
    ],
    SearchPhoneRules: [
      "Không có từ khóa",
      "Bắt đầu bằng",
      "Có chứa",
      "Không chứa",
      "Kết thúc bằng",
    ],
    SearchPhoneRulesMessage: [
      "Bắt đầu bằng: nhập tối đa 4 số",
      "Có chứa: nhập tối đa 4 số",
      "Không chứa: nhập tối đa 1 số",
      "Kết thúc bằng: nhập tối đa 4 số",
    ],
    Message: {
      Destiny: "Mệnh phong thủy cần có giá trị",
      Zodiac: "Cung hoàng đạo cần giá trị",
      Numerology: "Thần số học cần có giá trị",
    },
  },
  NiceSimRefactory: {
    MainLabel: "SIM số đẹp cần thay",
    QRCodeString: "Đoạn mã QRCode của eSIM",
    RefactorSim: "Thay eSIM",
    Columns: {
      createdAt: "Thời gian tạo",
      updatedAt: "Thời gian cập nhật",
      name: "Tên",
      code: "Mã",
      serial: "Mã serial",
      type: "Loại",
      status: "Trạng thái",
      description: "Mô tả",
    },
    Message: {
      RefactorSuccess: "Thay eSIM thành công !",
      RefactorFailed: "Thay eSIM thất bại",
      NeedQR: "Vui lòng nhập đoạn mã của QRCode",
      NeedSerial: "Vui lòng nhập mã Serial",
      Confirm: "Xác nhận thay eSIM cho SIM hiện tại ?",
      QRCodeString: "Nhập đoạn mã QRCode hoặc tải lên ảnh QRCode để có mã...",
    },
  },
  SpecialPrice: {
    Title: "Giá ưu đãi",
    Columns: {
      createdAt: "Thời gian tạo",
      updatedAt: "Thời gian cập nhật",
      name: "Tên",
      code: "Mã",
      price: "Giá tiền",
      merchant: "Đối tác",
      goods: "Hàng hoá",
      variant: "Biến thể",
      note: "Ghi chú",
      specialKey: "Khoá giá ưu đãi",
      type: "Loại",
      status: "Trạng thái",
      order: "Order",
    },
    Detail: {
      name: "Tên",
      code: "Mã",
      merchant: "Đối tác",
      goods: "Hàng hoá",
      variant: "Biến thể",
      status: "Trạng thái",
      price: "Giá tiền",
      specialKey: "Khoá giá ưu đãi",
      note: "Ghi chú",
    },
    Message: {
      GoodsIsBlocked: "Không thể cập nhật do đã khoá thông tin hàng hoá",
    },
  },
};
